import DeleteConfirmationDialog from "./DeleteConfirmationDialog";
import messageResource from '../../messageResource'

export default class DeleteProjectPopupConfirmationDialog extends DeleteConfirmationDialog {
    constructor($container, cancelHandler, deleteHandler) {
        super($container, cancelHandler, deleteHandler);
    }

    titleText()
    {
        return messageResource.getMessage("delete.confirm.dialog.cp.popup.project", [this.state.entityName]);
    }

    firstOrangeSentence()
    {
        return messageResource.getMessage("delete.confirm.dialog.cp.popup.first_orange_sentence", [messageResource.getMessage("common.Project")]);
    }

    secondOrangeSentence()
    {
        return messageResource.getMessage(this.hasTimeTrack() ?
                                          "delete.confirm.dialog.cp.second_orange_sentence.please_confirm_actions" :
                                          "delete.confirm.dialog.cp.second_orange_sentence.please_confirm");
    }

    removeEntitiesPointText()
    {
        var pronoun = messageResource.getMessage("delete.confirm.dialog.its");
        return messageResource.getMessage("delete.confirm.dialog.cp.popup.remove_entities_point_text",
                                          [messageResource.getMessage("common.project"), pronoun]);
    }

    removeTimeTrackPointText()
    {
        return messageResource.getMessage("delete.confirm.dialog.cp.remove_time_track_point_text")
    }

    deleteButtonText()
    {
        if (this.hasTimeTrack())
            return messageResource.getMessage("delete.confirm.dialog.delete_task_with_entries");
        else
            return messageResource.getMessage("delete.confirm.dialog.cp.delete_button_text.no_tt")
    }
}


// WEBPACK FOOTER //
// ./web/js/cptManagement/deleteConfirmationDialog/DeleteProjectPopupConfirmationDialog.js